import { formatImageSource } from '../formatImageSource/formatImageSource'

// CSS width of a result tile on the discovery screens: a third of the 420px
// consumer max width, less padding and gaps (~117px). The interstitial's 80px
// orbit cards reuse the same size on purpose — one size across the grid, the orbit
// and the PDP prefetch keeps every request after the first a cache hit.
export const DISCOVERY_TILE_IMAGE_WIDTH = 120

// The `src`/`srcSet` a discovery result tile renders, and the exact source to pass
// to `preloadImages` when warming it. Keep the two in lockstep through this
// helper: a different width is a different URL, and the warm-up would miss.
export function discoveryTileImageSource(url: string) {
  return formatImageSource(url, DISCOVERY_TILE_IMAGE_WIDTH)
}
